import { useContactFields } from 'modules/contacts/hooks/use-contact-fields'
import {
  ContactFieldApiInterface,
  ContactFilterConditionInterface,
  ContactFilterType,
} from 'modules/contacts/types/contact-filter-interface'
import { getEmptyFilter } from 'modules/contacts/utils/get-empty-filter'
import { getFilter } from 'modules/contacts/utils/get-filter'
import { useCallback, useEffect, useState } from 'react'

export interface FilterWithConditionsInterface {
  conditions: ContactFilterConditionInterface[]
  setConditions: React.Dispatch<React.SetStateAction<ContactFilterConditionInterface[]>>
  filter: ContactFilterType
  setFilter: React.Dispatch<React.SetStateAction<ContactFilterType>>
  filtersReady: boolean
  clearFilter: () => void
  filterFields?: ContactFieldApiInterface
}

export const useFilterWithConditions = (
  defaultFilters?: ContactFilterType,
): FilterWithConditionsInterface => {
  const { fields } = useContactFields()

  const [filter, setFilter] = useState<ContactFilterType>(defaultFilters || getEmptyFilter())

  const [conditions, setConditions] = useState<ContactFilterConditionInterface[]>([])

  const [filtersReady, setFiltersReady] = useState(false)

  const clearFilter = useCallback(() => {
    setFilter(getEmptyFilter(fields))
  }, [fields, setFilter])

  useEffect(() => {
    if (fields) {
      clearFilter()
      if (conditions.length !== 0) {
        setFilter(prev => ({
          ...prev,
          ...getFilter(conditions, fields),
        }))
      }
      setFiltersReady(true)
    }
  }, [fields, conditions, setFilter, clearFilter])

  return {
    conditions,
    setConditions,
    filter,
    setFilter,
    filtersReady,
    clearFilter,
    filterFields: fields,
  }
}
